import { render } from "./manageAssets.vue?vue&type=template&id=275d13e2&scoped=true"
import script from "./manageAssets.vue?vue&type=script&lang=js"
export * from "./manageAssets.vue?vue&type=script&lang=js"

import "./manageAssets.vue?vue&type=style&index=0&id=275d13e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275d13e2"]])

export default __exports__